import React from 'react';
import HostingerStyleServiceTemplate from '../../components/HostingerStyleServiceTemplate';
import FounderInsight from '../../components/FounderInsight';
import { FaBuilding, FaHardHat, FaMobileAlt, FaSearch, FaUsers, FaCode, FaRocket, FaTools, FaMapMarkerAlt, FaShieldAlt } from 'react-icons/fa';

const WebConstructorasPage = () => {
  // Keyword principal: "página web barata"
  const mainKeyword = "página web barata";
  
  // Enlaces internos relacionados
  const relatedLinks = [
    { url: "/servicios/diseno-web-empresas", text: "Página web barata para empresas" },
    { url: "/servicios/diseno-web-autonomos", text: "Página web barata para autónomos" },
    { url: "/servicios/diseno-web-arquitectos", text: "Página web barata para arquitectos" },
    { url: "/servicios/landing-pages", text: "Landing pages económicas" },
    { url: "/precios", text: "Ver todos nuestros precios" },
    { url: "/proceso", text: "Conoce nuestro proceso de trabajo" }
  ];
  
  // Lista de beneficios adaptados al buyer persona José
  const benefits = [
    {
      title: "Capta clientes de mayor valor",
      description: "Una web profesional atrae proyectos de mayor envergadura. Los clientes con presupuestos elevados buscan constructoras con presencia online profesional."
    },
    {
      title: "Muestra tus obras 24/7",
      description: "Tu portfolio online trabaja cuando tú descansas. Presenta tus mejores proyectos con fotografías profesionales y descripciones técnicas."
    },
    {
      title: "Diferénciate de la competencia",
      description: "El 70% de las constructoras tienen webs anticuadas o poco profesionales. Destaca con un diseño moderno que genere confianza inmediata."
    },
    {
      title: "Expande tu radio de acción",
      description: "Consigue proyectos más allá de tu localidad. Una web optimizada te posiciona para captar clientes en toda la región o incluso a nivel nacional."
    },
    {
      title: "Genera credibilidad instantánea",
      description: "El 80% de los clientes investigan online antes de contactar. Una web profesional establece confianza y seriedad desde el primer vistazo."
    },
    {
      title: "Retorno de inversión con un solo proyecto",
      description: "Con un único proyecto mediano captado a través de la web, recuperas varias veces la inversión total. Cada proyecto adicional es beneficio neto."
    }
  ];
  
  // Características adaptadas al buyer persona José
  const features = [
    {
      icon: <FaBuilding />,
      title: "Portfolio visual de obras",
      description: "Galería de proyectos con imágenes de alta calidad y descripción técnica. Presentación impactante de tus mejores obras para causar la mejor impresión."
    },
    {
      icon: <FaMobileAlt />,
      title: "Diseño responsive profesional",
      description: "Tu web se adaptará perfectamente a cualquier dispositivo. Las imágenes y detalles se visualizarán correctamente tanto en móviles como en ordenadores."
    },
    {
      icon: <FaHardHat />,
      title: "Servicios clasificados por especialidad",
      description: "Organización clara por tipo de obra (residencial, comercial, industrial, reformas), facilitando que los clientes encuentren lo que buscan."
    },
    {
      icon: <FaSearch />,
      title: "SEO para constructoras",
      description: "Posicionamiento específico para términos como 'constructora en [tu ciudad]' o especialidades concretas. Aparece cuando los clientes buscan tus servicios."
    },
    {
      icon: <FaTools />,
      title: "Presentación detallada de servicios",
      description: "Secciones específicas para cada servicio: obra nueva, reformas, rehabilitación, etc. Claridad para el cliente sobre todo lo que ofreces."
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Optimización local integrada",
      description: "Configuración para Google Business Profile y presencia en mapas. Destaca cuando busquen constructoras en tu zona con información consistente."
    }
  ];
  
  // Planes de precios adaptados
  const plans = [
    {
      title: 'Web para Constructoras Básica',
      price: 300,
      period: 'pago único',
      description: 'Web profesional para comenzar a destacar tu empresa de construcción online.',
      features: [
        { text: 'Hasta 5 páginas principales', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Portfolio básico (hasta 10 proyectos)', included: true },
        { text: 'Formulario de contacto', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Información de servicios', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Sistema de presupuestos online', included: false },
        { text: 'Optimización SEO avanzada', included: false },
        { text: 'Estadísticas de visitantes', included: false },
      ],
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=constructora-basica',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web para Constructoras Profesional',
      price: 400,
      period: 'pago único',
      description: 'La más elegida. Web completa con portfolio mejorado para captar clientes de calidad.',
      features: [
        { text: 'Entre 5-10 páginas', included: true },
        { text: 'Adaptada a todos los dispositivos', included: true },
        { text: 'Portfolio avanzado (hasta 20 proyectos)', included: true },
        { text: 'Página individual para proyectos principales', included: true },
        { text: 'Formulario de presupuestos básico', included: true },
        { text: 'Presentación del equipo profesional', included: true },
        { text: 'Testimonios de clientes', included: true },
        { text: 'Optimización SEO local', included: true },
        { text: 'Galería optimizada para obras', included: true },
        { text: 'Configuración Google Business Profile', included: true },
      ],
      isPopular: true,
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=constructora-pro',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web para Constructoras Premium',
      price: 500,
      period: 'pago único',
      description: 'Solución completa para constructoras que buscan destacar en un mercado competitivo.',
      features: [
        { text: 'Entre 10-15 páginas', included: true },
        { text: 'Diseño exclusivo de alta gama', included: true },
        { text: 'Portfolio extenso con categorías', included: true },
        { text: 'Sistema avanzado de presupuestos', included: true },
        { text: 'Videos de obras y proyectos', included: true },
        { text: 'Sección de noticias/blog', included: true },
        { text: 'Fichas detalladas de proyectos', included: true },
        { text: 'Estrategia SEO completa', included: true },
        { text: 'Conexión con redes sociales', included: true },
        { text: 'Análisis de tráfico avanzado', included: true },
      ],
      buttonText: 'Solicitar presupuesto gratis',
      buttonLink: '/reserva?plan=constructora-premium',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    }
  ];
  
  // Proceso paso a paso simplificado
  const processSteps = [
    {
      number: 1,
      title: "Análisis y planificación",
      description: "Estudiamos tu empresa, proyectos destacados y servicios. Planificamos una web que refleje el profesionalismo y seriedad de tu constructora.",
      icon: <FaUsers />
    },
    {
      number: 2,
      title: "Diseño y desarrollo",
      description: "Creamos una web con diseño que transmita confianza y solidez. Implementamos el portfolio visual y todas las funcionalidades necesarias.",
      icon: <FaCode />
    },
    {
      number: 3,
      title: "Lanzamiento y posicionamiento",
      description: "Publicamos tu web, te formamos en su uso y configuramos estrategias SEO para que te encuentren los clientes adecuados para tus servicios.",
      icon: <FaRocket />
    }
  ];
  
  // Comparativa directa
  const comparisonItems = [
    {
      label: "Diseño que transmite solidez y confianza",
      us: true,
      others: false
    },
    {
      label: "Portfolio optimizado para constructoras",
      us: true,
      others: false
    },
    {
      label: "Posicionamiento SEO especializado",
      us: true,
      others: false
    },
    {
      label: "Optimización de imágenes de obras",
      us: true,
      others: false
    },
    {
      label: "Presentación profesional de servicios",
      us: true,
      others: false
    },
    {
      label: "Formación en actualización de contenidos",
      us: true,
      others: false
    }
  ];
  
  // Testimonio real para el sector
  const testimonial = {
    text: "Durante años dependimos de contactos y recomendaciones para conseguir proyectos. Con la nueva web profesional, hemos captado clientes que nunca habrían llegado a nosotros por canales tradicionales. El portfolio online nos permite mostrar nuestro trabajo y calidad antes de la primera reunión, lo que ha mejorado significativamente la calidad de los contactos. Hemos conseguido tres proyectos importantes directamente a través de la web que han multiplicado por ocho la inversión realizada.",
    author: "Antonio García",
    position: "Director",
    company: "Construcciones García",
    avatar: "/servicios/testimonios/constructora.webp"
  };
  
  const founderMessage = "En el sector de la construcción, la confianza es fundamental. Una buena web no solo debe mostrar proyectos anteriores, sino transmitir seguridad y solidez. Hemos diseñado nuestras webs para constructoras centrándonos en crear esa primera impresión de profesionalidad que luego impulsa contactos cualificados.";
  
  // FAQs específicas para web de constructoras
  const faqs = [
    {
      question: "¿Por qué necesito una web profesional como constructora?",
      answer: "Una web profesional es actualmente indispensable para las constructoras por varios motivos estratégicos: 1) Es tu portfolio digital disponible 24/7, mostrando tus obras y proyectos cuando los clientes buscan fuera de horario laboral; 2) El 80% de los clientes potenciales investigan online antes de contactar con una constructora; 3) Proporciona credibilidad instantánea y primera impresión de seriedad; 4) Expande tu alcance geográfico, permitiéndote captar proyectos más allá de tu localidad; 5) Te posiciona como experto en especialidades concretas (reformas, obra nueva, rehabilitación, etc.); 6) Diferencia tu empresa de la competencia mediante un diseño profesional que transmite confianza; 7) Atrae proyectos de mayor envergadura y presupuesto, ya que clientes con inversiones importantes buscan constructoras con presencia digital sólida; 8) Muestra testimonios y casos de éxito que refuerzan tu experiencia. Según datos del sector, las constructoras con presencia online profesional consiguen un 35% más de consultas cualificadas que aquellas que dependen exclusivamente del boca a boca tradicional.",
      category: "Estrategia"
    },
    {
      question: "¿Cómo presentaréis mis obras y proyectos en la web?",
      answer: "Tu portfolio de proyectos constructivos recibirá un tratamiento profesional con estas características: 1) Sistema de galerías de alta calidad que mantiene la resolución de tus imágenes, con visualización ampliada para apreciar detalles; 2) Organización en categorías según tus especialidades (residencial, industrial, comercial, reformas, etc.); 3) Página individual detallada para cada proyecto importante con múltiples imágenes, descripción técnica, y características destacadas; 4) Optimización de imágenes para velocidad de carga sin pérdida de calidad; 5) Filtros de búsqueda para que los visitantes encuentren referencias similares a sus necesidades; 6) Testimonios de clientes asociados a proyectos específicos; 7) Información sobre certificaciones, premios o reconocimientos obtenidos. La presentación estará diseñada para impresionar tanto a clientes particulares como a profesionales del sector, con un enfoque que equilibra el impacto visual con la información técnica relevante. Te formaremos para que puedas actualizar fácilmente el portfolio con nuevos proyectos.",
      category: "Portfolio"
    },
    {
      question: "¿Qué información necesito proporcionar para crear la web?",
      answer: "Para crear tu web de constructora necesitamos la siguiente información básica: 1) Descripción de la empresa, historia, misión y valores; 2) Listado de servicios que ofreces con breve descripción de cada uno; 3) Fotografías de alta calidad de proyectos realizados (idealmente 5-10 proyectos destacados con varias fotos por proyecto); 4) Información sobre el equipo, especialmente responsables principales; 5) Testimonios de clientes (si dispones de ellos); 6) Certificaciones, homologaciones o pertenencia a asociaciones profesionales; 7) Datos de contacto completos; 8) Cualquier información adicional sobre metodología de trabajo, garantías ofrecidas, etc. No te preocupes si no dispones de todo el material en calidad profesional. Podemos trabajar con lo que tengas y guiarte para mejorar ciertos aspectos. También podemos ayudarte con la redacción profesional de contenidos si proporcionas la información técnica básica. La clave para una web efectiva es mostrar la calidad y profesionalidad de tus obras, por lo que las fotografías de proyectos son especialmente importantes.",
      category: "Contenidos"
    },
    {
      question: "¿La web incluye sistema de presupuestos online?",
      answer: "Ofrecemos diferentes opciones para la gestión de presupuestos online, según tus necesidades: 1) En el plan Básico, incluimos un formulario de contacto especializado donde los clientes pueden detallar su proyecto para solicitar presupuesto; 2) En el plan Profesional, incorporamos un formulario de presupuestos básico con campos específicos para tipo de obra, metros cuadrados, ubicación y otros detalles relevantes; 3) En el plan Premium, implementamos un sistema avanzado con estimador automático según parámetros predefinidos. Para sistemas de presupuestación más complejos o calculadoras específicas según precios por metro cuadrado u otras variables, ofrecemos desarrollos a medida con coste adicional. Estos sistemas personalizados no están incluidos en los planes estándar y se presupuestan individualmente según requerimientos. La experiencia demuestra que incluso el formulario básico de presupuestos bien diseñado aumenta considerablemente las solicitudes cualificadas.",
      category: "Funcionalidades"
    },
    {
      question: "¿Cuántas páginas incluye cada plan?",
      answer: "Cada plan incluye un número limitado de páginas para mantener la relación calidad-precio: 1) El plan Básico incluye hasta 5 páginas principales (inicio, servicios, portfolio, sobre nosotros, contacto); 2) El plan Profesional permite entre 5-10 páginas, añadiendo páginas individuales para algunos proyectos destacados, testimonios detallados, o páginas específicas por tipo de servicio; 3) El plan Premium permite entre 10-15 páginas, permitiendo un desglose más detallado de servicios, más páginas de proyectos individuales y contenido adicional. Si necesitas más páginas de las incluidas en tu plan, estas tienen un coste adicional de 50€ por página. Para webs realmente extensas con más de 15 páginas, recomendamos solicitar un presupuesto personalizado. Es importante destacar que la mayoría de constructoras consiguen excelentes resultados con el número de páginas incluido en los planes estándar, ya que la calidad y organización del contenido es más importante que la cantidad.",
      category: "Planes"
    },
    {
      question: "¿Cómo funcionará el mantenimiento de la web?",
      answer: "El mantenimiento mensual de 20€ incluye todos los aspectos técnicos y de soporte: 1) Alojamiento en servidores de alta velocidad optimizados para imágenes de construcción; 2) Renovación anual del dominio; 3) Certificado de seguridad SSL; 4) Copias de seguridad diarias; 5) Actualizaciones de seguridad y del sistema; 6) Soporte técnico por email y teléfono; 7) Pequeñas modificaciones de contenido (hasta 30 minutos mensuales); 8) Monitorización de rendimiento y disponibilidad. Además, te proporcionamos acceso a un panel de administración intuitivo donde podrás: añadir nuevos proyectos al portfolio, actualizar imágenes y descripciones, y modificar información de contacto o servicios. Para constructoras, incluimos una formación inicial personalizada para que tu equipo pueda mantener actualizado el portfolio sin depender constantemente de nosotros. Si necesitas modificaciones mayores o ampliaciones, disponemos de tarifas especiales para clientes de mantenimiento. El sistema está especialmente optimizado para gestionar eficientemente imágenes de alta resolución de obras y proyectos sin afectar al rendimiento.",
      category: "Mantenimiento"
    }
  ];

  return (
    <HostingerStyleServiceTemplate
      // SEO optimizado para constructoras
      pageTitle="Web para Constructoras desde 300€ | Portfolio Digital Profesional"
      pageDescription="Diseño web especializado para empresas constructoras. Portfolio visual de alto impacto, presupuestos online y posicionamiento local para captar proyectos de calidad."
      pageKeywords="página web barata constructoras, web para constructoras, diseño web construcción, portfolio constructora online, página web empresa construcción"
      canonicalUrl="https://webabajocoste.es/servicios/diseno-web-constructoras"
      
      // Hero adaptado al buyer persona
      heroTitle="Web para constructoras desde 300€ (capta proyectos de mayor valor)"
      heroSubtitle="Portfolio digital profesional que muestra tus obras con máximo impacto visual. Diseño que transmite confianza y seriedad para atraer clientes de calidad."
      heroImage="/servicios/tipo-cliente/hero-constructoras.webp"
      badges={['Desde 300€ (pago único)', 'Portfolio visual profesional', 'Diseño que transmite confianza', 'Mantenimiento 20€/mes']}
      heroCTAText="Solicitar presupuesto gratuito"
      heroCTALink="/reserva"
      
      // Secciones adaptadas
      pricingTitle="Planes para constructoras"
      pricingSubtitle="Elige el plan que mejor se adapte a tus necesidades. Todos incluyen soporte técnico y mantenimiento por 20€/mes."
      plans={plans}
      
      featuresTitle="¿Por qué nuestra web es ideal para constructoras?"
      features={features}
      
      // Componente FounderInsight insertado como contenido personalizado
      customContent={
        <FounderInsight 
          insightText={founderMessage}
          founderName="Jaime Vela"
          founderTitle="Co-fundador y Director de Marketing"
          avatarSrc="/sobre nosotros/foto-jaime.webp"
        />
      }
      
      processTitle="Creamos tu web en 3 sencillos pasos"
      processSteps={processSteps}
      
      comparisonTitle="¿Por qué elegirnos para tu web de construcción?"
      comparisonItems={comparisonItems}
      
      testimonial={testimonial}
      
      benefitsTitle="Ventajas de una web profesional para tu constructora"
      benefits={benefits}
      
      faqTitle="Preguntas frecuentes sobre webs para constructoras"
      faqCategories={["Estrategia", "Portfolio", "Contenidos", "Funcionalidades", "Planes", "Mantenimiento"]}
      faqs={faqs}
      
      ctaTitle="Destaca en el competitivo sector de la construcción"
      ctaDescription="Una web profesional es hoy imprescindible para captar proyectos de calidad. Invierte en tu presencia digital y amplía tu alcance más allá de los contactos tradicionales."
      ctaButtonText="Solicitar presupuesto gratuito"
      ctaButtonLink="/reserva"
      
      relatedLinks={relatedLinks}
    />
  );
};

export default WebConstructorasPage; 

